// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3jSsI","label":"SetPasswdForm_label__26UjC"};